<script lang="ts" setup>
withDefaults(
  defineProps<{
    text?: string;
    requiredMark?: boolean;
    tooltip?: string;
    tooltipType?: 'info' | 'warning';
  }>(),
  {
    tooltipType: 'info',
  },
);
</script>

<template>
  <div
    v-if="text"
    class="m-input-label mb-2 d-flex align-center ga-1"
  >
    {{ text }}
    <span
      v-if="requiredMark"
      class="text-error"
    >
      *
    </span>

    <!-- Info tooltip -->
    <v-tooltip v-if="tooltip">
      <template #activator="{ props }">
        <v-icon
          v-bind="props"
          class="ml-1"
          :color="tooltipType === 'info' ? 'primary' : 'warning'"
          size="16"
        >
          mdi-information
        </v-icon>
      </template>

      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.m-input-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
</style>
